export default () => ({
    cities: [],
    countries: [],
    provinces: [],
    issuedCountries: [],
    issuedCities: [],
    birthCities: [],
    issuedProvinces: []
})